export default "__VITE_ASSET__BvK6sYnZ__"